import { useList } from '@refinedev/core';
import type { PublicationListOut } from '@/api/generated/schemas';

export const SHELF_LIMIT = 10;

/** The first publications a collection resolves to, in the order the app's
 * feed shows them — the server resolves the collection's query. `total`
 * rides on `x-total-count`. Cached per collection id, so a tab switch never
 * refetches a shelf. */
export const useCollectionShelfPublications = (
  collectionId: number,
  enabled = true
) => {
  const { result, query } = useList<PublicationListOut>({
    resource: `user_catalog.collections.${collectionId}.publications`,
    pagination: { pageSize: SHELF_LIMIT },
    // The server appends explicit sort after the collection's intrinsic
    // order, so ordered collections keep their order and popularity only
    // breaks the remaining ties.
    sorters: [{ field: 'popularity', order: 'desc' }],
    meta: { trailingSlash: false },
    queryOptions: { enabled },
  });

  return {
    publications: result?.data,
    total: result?.total,
    isLoading: !enabled || query.isLoading,
  };
};
